import React from 'react';
import { BED_TYPES, bedTypeLabel } from '../../constants/roomConfig';

const DEFAULT_BED = { type: BED_TYPES[0].type, region: BED_TYPES[0].region, count: 1 };

export default function BedTypeList({ beds = [], onChange }) {
  const rows = beds.length > 0 ? beds : [{ ...DEFAULT_BED }];

  const handleSelect = (index, value) => {
    const [type, region] = value.split('||');
    onChange(rows.map((b, i) => (i === index ? { ...b, type, region } : b)));
  };

  const handleCount = (index, value) => {
    if (value === '') {
      onChange(rows.map((b, i) => (i === index ? { ...b, count: '' } : b)));
      return;
    }
    const parsed = parseInt(value, 10);
    const count = isNaN(parsed) ? 1 : Math.max(1, parsed);
    onChange(rows.map((b, i) => (i === index ? { ...b, count } : b)));
  };

  const handleCountBlur = (index, value) => {
    const count = Math.max(1, parseInt(value, 10) || 1);
    onChange(rows.map((b, i) => (i === index ? { ...b, count } : b)));
  };

  const handleAdd = () => onChange([...rows, { ...DEFAULT_BED }]);

  const handleRemove = (index) => onChange(rows.filter((_, i) => i !== index));

  return (
    <div>
      <table className="table table-sm table-bordered mb-2">
        <thead>
          <tr>
            <th>Bed Type</th>
            <th style={{ width: 150 }}>No. of Beds / Room</th>
            {rows.length > 1 && <th style={{ width: 50 }} />}
          </tr>
        </thead>
        <tbody>
          {rows.map((bed, i) => (
            <tr key={i} role="row">
              <td>
                <select
                  className="form-select form-select-sm"
                  value={`${bed.type}||${bed.region}`}
                  onChange={(e) => handleSelect(i, e.target.value)}
                >
                  {[...BED_TYPES].sort((a, b) => bedTypeLabel(a).localeCompare(bedTypeLabel(b))).map((bt) => (
                    <option key={`${bt.type}||${bt.region}`} value={`${bt.type}||${bt.region}`}>
                      {bedTypeLabel(bt)}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  min={1}
                  value={bed.count}
                  onChange={(e) => handleCount(i, e.target.value)}
                  onBlur={(e) => handleCountBlur(i, e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </td>
              {rows.length > 1 && (
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleRemove(i)}
                    aria-label="Remove"
                  >×</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleAdd}>
        + Add Bed
      </button>
    </div>
  );
}
